/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateShopCommand { 
    name: string;
    code?: string | null;
    description: string;
    imageUrl?: string | null;
    isVisible?: boolean;
    checkStock?: boolean;
    tcposId?: number;
    cdpf?: string | null;
    orderPlacementRange?: number;
    hideIncompleteArticles?: boolean;
    businessType?: number;
    siteId: number;
    hubId?: number | null;
    trayLimit: number;
    articleRatingFilterType?: number;
    notesEnabled?: boolean;
    canteenTimeSlotsEnabled?: boolean;
    sendOrdersToCuce?: boolean;
    cuceId?: number | null;
}

